import { createApi } from '@reduxjs/toolkit/query/react';
import { endpoints } from '../../../helper/endpoints';
import { Broker } from '../../../shared/types/quotes';
import { axiosBaseQuery } from '../axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const brokerApi = createApi({
	reducerPath: 'brokerApi',
	baseQuery: axiosBaseQuery({ baseUrl: '' }),
	tagTypes: ['BROKER'],
	endpoints: (builder) => ({
		getBrokerById: builder.query<Broker, number>({
			providesTags: (result, error, brokerId) => [{ type: 'BROKER', id: brokerId }],
			query: (brokerId) => ({
				url: endpoints.GET_BROKER_DETAILS_BY_ID,
				method: 'POST',
				data: JSON.stringify(brokerId),
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json, text/plain, */*',
				},
			}),
			transformErrorResponse: (response) => {
				console.log('ERROR RESPONSE getBrokerById', response);
				return response;
			},
			transformResponse: (response) => {
				console.log('getBrokerById', response);
				return response?.result?.[0];
			},
		}),
	}),
});

// Export hooks for usage in functional components
export const { useGetBrokerByIdQuery, useLazyGetBrokerByIdQuery } = brokerApi;
